export default __webpack_public_path__ + "static/media/Logo.cb5e7268.jpg";